import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import debounce from "lodash.debounce";
import clonedeep from "lodash.clonedeep";
import _ from "i18n";

import {
  setPresentationThankingSlide,
  setPresentationQuestionsSlide,
  setPresentationExtraSlides,
  setPresentationExtraSlidesContent,
  setDashboardSlides,
  setPresentationCurrentSlideIndex,
  setShowFrameExtraSlides,
  setCommentSlideCode
} from "Actions";
import { createEditorState } from "Utils";

import { Switch, Popconfirm } from "antd";
import { Tooltip } from "antd";

import styles from "./PreparePresentation.local.scss";
import { ICONS, SvgIcon } from "../Common/Icons";

class ExtraSlidesConfig extends Component {
  constructor(props) {
    super(props);

    // const {
    //   dashboardData: { slides }
    // } = this.props;

    this.state = {
      slideContent: createEditorState(""),
      selectedExtraSlide: null,
      page: null,
      title: "",
      nbrOfSlides: this.getNbrOfSlides(),
      isExtraSlideModalVisible: false
    };

    this.handleSetExtraSlideContent = debounce(
      this.handleSetExtraSlideContent,
      1000
    );
  }

  componentDidMount() {
    this.handleSetDashboardSlides();
  }

  componentDidUpdate(
    prevProps: Readonly<P>,
    prevState: Readonly<S>,
    snapshot: SS
  ) {
    const {
      dashboardData: { slides },
      thankingSlide,
      questionsSlide,
      extraSlides
    } = this.props;

    if (
      prevProps.thankingSlide !== thankingSlide ||
      prevProps.questionsSlide !== questionsSlide ||
      prevProps.dashboardData.slides.length !== slides.length ||
      prevProps.extraSlides.slides.length !== extraSlides.slides.length ||
      prevProps.extraSlides.enabled !== extraSlides.enabled
    ) {
      this.handleSetDashboardSlides();
    }
  }

  //************************* SET DASHBOARD SLIDES TO UPDATE ON ANY CHANGE ******************//
  handleSetDashboardSlides = newExtraSlides => {
    const {
      year,
      dashboardData: { slides },
      thankingSlide,
      questionsSlide,
      extraSlides,
      currentSlideIndex,
      dispatch
    } = this.props;

    let newSlides = clonedeep(slides);

    let extra = newExtraSlides ? newExtraSlides : extraSlides.slides;

    newSlides = newSlides.filter(
      slide =>
        !["EXTRA_SLIDE", "QUESTIONS_SLIDE", "THANKING_SLIDE"].includes(
          slide.layout.type
        )
    );

    extraSlides.enabled &&
      extra.forEach(item => {
        newSlides.splice(item.page - 1, 0, {
          id: 0,
          labels: { fr: item.title, en: "", nl: "" },
          layout: {
            label: item.title,
            type: "EXTRA_SLIDE",
            config: {
              background: "url(/img/back_blue.png)",
              componentsBackground: "#FFFFFF"
            },
            components: [item]
          }
        });
      });
    if (thankingSlide) {
      newSlides.push({
        id: 0,
        layout: {
          label: { fr: "Remerciement", en: "", nl: "" },
          type: "THANKING_SLIDE",
          config: {
            background: "url(/img/back_blue.png)",
            componentsBackground: "#FFFFFF"
          },
          data: {}
        }
      });
    }

    if (questionsSlide) {
      newSlides.push({
        id: 0,
        layout: {
          label: { fr: "Questions", en: "", nl: "" },
          type: "QUESTIONS_SLIDE",
          config: {
            background: "url(/img/back_blue.png)",
            componentsBackground: "#FFFFFF"
          },
          data: {}
        }
      });
    }

    if (currentSlideIndex >= newSlides.length) {
      dispatch(setPresentationCurrentSlideIndex(newSlides.length - 1));
      slides &&
        slides[newSlides.length - 1] &&
        dispatch(setCommentSlideCode(slides[newSlides.length - 1].code));

      const { target } = this.props;
      year &&
        window.history.pushState(
          "",
          "",
          `/prepare-presentation/${target}/${newSlides.length}?year=${year}`
        );
    }

    dispatch(setDashboardSlides(newSlides));
    extra.forEach(extraSlide => {
      const slide = newSlides.filter(
        slide =>
          slide.layout.components &&
          slide.layout.components.length > 0 &&
          slide.layout.components[0].key === extraSlide.key
      );
      if (slide.length > 0) extraSlide.page = newSlides.indexOf(slide[0]) + 1;
    });
  };

  getNbrOfSlides = () => {
    const {
      dashboardData: {
        config: { slidesOrder }
      },
      extraSlides: { slides }
    } = this.props;

    return slidesOrder.length + slides.length;
  };

  //**************** ENABLING / DISABLING SLIDES *************//
  onChangeThankingSlide = () => {
    const { dispatch, thankingSlide } = this.props;
    dispatch(setPresentationThankingSlide(thankingSlide ? 0 : 1));
  };

  onChangeQuestionsSlide = () => {
    const { dispatch, questionsSlide } = this.props;
    dispatch(setPresentationQuestionsSlide(questionsSlide ? 0 : 1));
  };

  onChangeExtraSlideEnabling = () => {
    const { dispatch, extraSlides } = this.props;
    dispatch(setPresentationExtraSlides(extraSlides.enabled ? 0 : 1));
    if (extraSlides && extraSlides.showFrame)
      dispatch(setShowFrameExtraSlides(false));
  };

  //******************   handle change on text editor  ****************//
  handleSetExtraSlideContent = ({ content, slideTitle }) => {
    const {
      dispatch,
      extraSlides: { slides }
    } = this.props;

    const { selectedExtraSlide } = this.state;

    slides.forEach(slide => {
      if (slide.key === selectedExtraSlide.key) {
        slide.content = content ? content : slide.content;
        slide.title = slideTitle ? slideTitle : slide.title;
      }
    });

    dispatch(setPresentationExtraSlidesContent(slides));

    this.handleSetDashboardSlides(slides);
  };

  //********************* EDIT EXTRA SLIDE *****************//
  handleEditExtraSlide = slide => {
    this.setState({
      ...this.state,
      selectedExtraSlide: slide
    });
    this.props.handleEditExtraSlide(slide);
  };

  //********************* ADD EXTRA SLIDE *****************//
  handleAddExtraSlide = () => {
    this.setState({
      ...this.state,
      selectedExtraSlide: null
    });
    this.props.handleAddExtraSlide();
  };

  //********************* DELETE EXTRA SLIDE *****************//
  handleDeleteExtraSlide = slideToDelete => {
    this.setState({
      selectedExtraSlide: null,
      page: null,
      slideContent: createEditorState(""),
      title: ""
    });
    this.props.handleDeleteExtraSlide(slideToDelete);
  };

  //******************** RENDERING BLOCKS ***************//
  renderSlideConfigBlock = ({
    title,
    description,
    extraSlides,
    checked,
    handleChange
  }) => {
    return (
      <div className={styles.slide_config_container}>
        <div>
          <span className={styles.title}>{_(title)}</span>
          <p>{description}</p>
          <Switch
            className={classnames(styles.switch)}
            defaultChecked={true}
            checked={checked}
            onChange={() => handleChange()}
          />
        </div>
        {extraSlides && checked ? (
          <div className={styles.contain_butt}>
            <div
              className={styles.add_butt}
              onClick={() => this.handleAddExtraSlide()}
            >
              +
            </div>
            <span>{_("addNew")}</span>
          </div>
        ) : (
          ""
        )}
        {extraSlides && this.renderExtraSlidesList()}
      </div>
    );
  };

  //******************** RENDERING EXTRA SLIDES LIST ***************//
  renderExtraSlidesList = () => {
    const { extraSlides, addExtraSlide, selectedSlide } = this.props;
    return (
      <div>
        {extraSlides.slides &&
          extraSlides.slides.map(slide => {
            return (
              <div
                key={`key_${slide.key}`}
                className={classnames(
                  styles.slides_btn_select,
                  selectedSlide &&
                  slide.key === selectedSlide.key &&
                  extraSlides.showFrame
                    ? styles.activated
                    : ""
                )}
              >
                <div className={styles.icon}>
                  <SvgIcon icon={ICONS.AIR_PLAY} />
                </div>
                <div className={styles.details}>
                  <span>{slide.title ? slide.title : _("newSlide")}</span>
                  <span>
                    {_("slidePosition")} : {slide.page}
                  </span>
                </div>
                <div className={styles.actions}>
                  <Tooltip placement="top" title={_("update")}>
                    <div
                      className={styles.action}
                      onClick={() => this.handleEditExtraSlide(slide)}
                    >
                      <SvgIcon icon={ICONS.EDIT_ICON} />
                    </div>
                  </Tooltip>
                  {((addExtraSlide && extraSlides.showFrame) ||
                    !extraSlides.showFrame) && (
                    <Tooltip placement="top" title={_("delete")}>
                      <Popconfirm
                        title={_("deleteConfirmation")}
                        okText={_("yes")}
                        cancelText={_("cancel")}
                        onConfirm={event => {
                          event.stopPropagation();
                          this.handleDeleteExtraSlide(slide);
                        }}
                        onCancel={event => {
                          event.stopPropagation();
                        }}
                      >
                        <div className={styles.action}>
                          <SvgIcon
                            icon={ICONS.DELETE_ICON}
                            onClick={event => {
                              event.stopPropagation();
                            }}
                          />
                        </div>
                      </Popconfirm>
                    </Tooltip>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  render() {
    const { thankingSlide, questionsSlide, extraSlides } = this.props;

    return (
      <div className={styles.extra_slide_container}>
        <div className={styles.config_block}>
          {this.renderSlideConfigBlock({
            title: _("presentationExtraSlide"),
            description: _("extraSlideDescription"),
            extraSlides: true,
            isRemarkVisible: extraSlides.enabled,
            checked: extraSlides.enabled,
            handleChange: this.onChangeExtraSlideEnabling
          })}
          {this.renderSlideConfigBlock({
            title: _("slideRemerciement"),
            description: _("remerciementDescription"),
            checked: thankingSlide,
            handleChange: this.onChangeThankingSlide
          })}
          {this.renderSlideConfigBlock({
            title: _("slideQuestions"),
            description: _("questionsDescription"),
            checked: questionsSlide,
            handleChange: this.onChangeQuestionsSlide
          })}
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  thankingSlide: state.presentation.presentationConfig.thankingSlide,
  questionsSlide: state.presentation.presentationConfig.questionsSlide,
  extraSlides: state.presentation.presentationConfig.extraSlides,
  target: state.presentation.presentationConfig.target,
  dashboardData: state.dashboard.data,
  currentSlideIndex: state.presentation.currentSlideIndex,
  extraSlideUsable: state.preparePresentation.extraSlideUsable
});

export default connect(mapStateToProps)(ExtraSlidesConfig);



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/ExtraSlidesConfig.js